module.exports = __webpack_public_path__ + "static/media/word.113ac212.svg";